import { Component } from '@angular/core';

@Component({
    selector: 'app-animation',
    templateUrl: './animation.component.html',
    standalone: true,
    styleUrl: './animation.component.scss'
})
export class AnimationComponent {


}
